import { useEffect, useRef, useState } from 'react';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks';
import { loginUserSuccess } from '../store/slices/authSlice';
import { exchangeGoogleCode } from '../services/api';

// Google SSO landing on the tenant subdomain. The backend hands the one-time
// code back in the URL fragment (#code=...), which the browser never sends to a
// server. We swap it for a tenant-bound JWT and complete the login.
export default function AuthCallbackPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode double-invoke (code is single-use)
    ran.current = true;
    const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
    const code = new URLSearchParams(hash).get('code');
    if (!code) { setError('Nedostaje kod za prijavu.'); return; }
    exchangeGoogleCode(code)
      .then((res) => {
        const token = res.data?.token;
        if (!token) { setError('Prijava nije uspjela.'); return; }
        // Clear the fragment so the code isn't left in history/back-nav.
        window.history.replaceState(null, '', window.location.pathname);
        dispatch(loginUserSuccess(token));
        sessionStorage.removeItem('homeSeen');
        navigate('/', { replace: true });
      })
      .catch(() => setError('Prijava nije uspjela ili je kod istekao.'));
  }, [dispatch, navigate]);

  return (
    <Container className="py-5 text-center">
      {error ? (
        <Alert variant="danger">{error} <a href="/login">Natrag na prijavu</a></Alert>
      ) : (
        <><Spinner animation="border" variant="secondary" /> <span className="ms-2">Prijava…</span></>
      )}
    </Container>
  );
}
